"use client";

import { Slot } from "@radix-ui/react-slot";
import * as React from "react";

import { buttonVariants } from "@/components/carousel/buttonVariants";
import type { CarouselButtonProps } from "@/components/carousel/types";
import { cn } from "@/utils/cn";

export const CarouselButton = React.forwardRef<
  HTMLButtonElement,
  CarouselButtonProps
>(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button";
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props}
    />
  );
});
CarouselButton.displayName = "CarouselButton";
